document.addEventListener('DOMContentLoaded', () => {
    const mySwiperNwSeeAction = new Swiper('.latest_abdesign__hype .seeinaction__preview_container.swiper', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        watchSlidesProgress: true,
    });
    const videoElementsNwSeeAction = document.querySelectorAll('.latest_abdesign__hype .seeinaction_interior_container .seeinaction__videoloop video');
    function playNextVideoNwSeeAction(event) {
        const currentVideoIndexNwSeeAction = Array.from(videoElementsNwSeeAction).indexOf(event.target);
        event.target.pause();
        const nextVideoIndexNwSeeAction = (currentVideoIndexNwSeeAction + 1) % videoElementsNwSeeAction.length;
        mySwiperNwSeeAction.slideTo(nextVideoIndexNwSeeAction);
        videoElementsNwSeeAction[nextVideoIndexNwSeeAction].play();
    }
    videoElementsNwSeeAction.forEach(video => {
        video.muted = true;
        video.addEventListener('ended', playNextVideoNwSeeAction);
    });
    if (videoElementsNwSeeAction.length > 0) {
        const firstVideo = videoElementsNwSeeAction[0];
        const playPromise = firstVideo.play();
        if (playPromise !== undefined) {
            playPromise.then(() => {
            }).catch(error => {
                console.log('Autoplay prevented. User interaction required to play video.');
            });
        }
    }
});